import { messages } from "./_generated/locales/en.js";
import { SOURCE_LOCALE_ID, createLocaleLoader } from "@bitcart/core/i18n";
// src/i18n/index.ts
const loadLazyLocale = createLocaleLoader(/* #__PURE__ */ Object.assign({
	"./_generated/locales/be.po": () => import("./_generated/locales/be.js"),
	"./_generated/locales/de.po": () => import("./_generated/locales/de.js"),
	"./_generated/locales/es.po": () => import("./_generated/locales/es.js"),
	"./_generated/locales/fr.po": () => import("./_generated/locales/fr.js"),
	"./_generated/locales/hi.po": () => import("./_generated/locales/hi.js"),
	"./_generated/locales/ko.po": () => import("./_generated/locales/ko.js"),
	"./_generated/locales/pl.po": () => import("./_generated/locales/pl.js"),
	"./_generated/locales/pseudo.po": () => import("./_generated/locales/pseudo.js"),
	"./_generated/locales/ru.po": () => import("./_generated/locales/ru.js"),
	"./_generated/locales/tr.po": () => import("./_generated/locales/tr.js"),
	"./_generated/locales/uk.po": () => import("./_generated/locales/uk.js")
}));
/**
* The UI Kit's catalog for the source locale, for apps that bundle their own statically.
*/
const UI_KIT_SOURCE_LOCALE_MESSAGES = messages;
/**
* Loads the UI Kit's catalog for a locale. Apps merge it into their own catalog, passed last so
* that the app can override the UI Kit's translations.
*/
const loadUiKitMessages = (locale) => locale === SOURCE_LOCALE_ID ? Promise.resolve(messages) : loadLazyLocale(locale);
export { UI_KIT_SOURCE_LOCALE_MESSAGES, loadUiKitMessages };

//# sourceMappingURL=index.js.map